export default __webpack_public_path__ + "static/media/Events.9200dcbc.svg";